import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Chip, Box, CircularProgress, Stack, useTheme } from '@mui/material';

const getPercentColorByDesvio = (desvio) => {
  if (typeof desvio !== 'number') return 'default';
  if (desvio >= 0) return 'success';
  if (desvio >= -20) return 'warning';
  return 'error';
};

const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(Number(value))) return '--';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(value));
};

const formatNumber = (value) => {
  if (value === null || value === undefined || isNaN(Number(value))) return '--';
  return Math.round(Number(value)).toLocaleString('pt-BR');
};

const FaturamentoContratosTable = ({ data = [], loading = false }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 220 }}>
        <CircularProgress size={48} thickness={4} />
      </Box>
    );
  }

  const sorted = [...data].sort((a, b) => {
    const aVal = typeof a.percentual_realizado === 'number' ? a.percentual_realizado : -Infinity;
    const bVal = typeof b.percentual_realizado === 'number' ? b.percentual_realizado : -Infinity;
    return bVal - aVal; // maior % primeiro
  });

  return (
    <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3, mt: 3 }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ px: 2, pt: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 700 }}>
          Faturamento
        </Typography>
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center', width: 80 }}>Ranking</TableCell>
            <TableCell sx={{ fontWeight: 700 }}>Contrato</TableCell>
            <TableCell sx={{ fontWeight: 700, textAlign: 'right' }}>Total Previsto</TableCell>
            <TableCell sx={{ fontWeight: 700, textAlign: 'right' }}>Total Realizado</TableCell>
            <TableCell sx={{ fontWeight: 700, textAlign: 'center' }}>%</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sorted.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5} align="center">
                <Typography color="text.secondary">Nenhum dado encontrado.</Typography>
              </TableCell>
            </TableRow>
          ) : (
            sorted.map((row, idx) => {
              let rankColor = undefined;
              const rank = idx + 1;
              if (idx === 0 || idx === 1 || idx === 2) rankColor = 'success.main';
              else if (idx >= 3 && idx <= 6) rankColor = 'warning.main';
              else if (idx >= 7) rankColor = 'error.main';
              const percent = typeof row.percentual_realizado === 'number' ? Math.round(row.percentual_realizado) : null;
              const chipColor = getPercentColorByDesvio(row.desvio_percentual_faturamento);
              return (
                <TableRow key={row.des_contrato || idx} hover>
                  <TableCell align="center" sx={{ fontWeight: 700, fontSize: 18, color: rankColor }}>{rank}</TableCell>
                  <TableCell>{row.des_contrato}</TableCell>
                  <TableCell align="right">{formatCurrency(row.meta_prevista)}</TableCell>
                  <TableCell align="right">{formatCurrency(row.producao_realizada)}</TableCell>
                  <TableCell align="center">
                    <Chip
                      label={percent !== null ? `${percent}%` : '--'}
                      color={chipColor}
                      size="small"
                      sx={{ fontWeight: 700, minWidth: 70 }}
                    />
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FaturamentoContratosTable;


